import cn from 'classnames';
import LoaderSvg from '~/assets/images/jane-outline-loader.svg';

interface LoadingViewProps {
  loading: boolean;
  message?: string;
  noMessage?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | 'full';
}

export const LoadingView = ({
  loading,
  message,
  noMessage,
  size,
}: LoadingViewProps) => {
  if (!loading) return null;

  size = size || 'sm';
  message = message ?? 'Just a second...';

  if (noMessage) message = undefined;

  const logoClasses = cn({
    'size-8': size === 'sm',
    'size-12': size === 'md',
    'size-24': size === 'lg',
    'size-36': size === 'xl',
    'size-48': size === '2xl',
    'size-64': size === '3xl',
    'size-80': size === '4xl',
    'size-full': size === 'full',
    'animate-pulsate': true,
  });

  const textClasses = cn({
    'text-sm': size === 'sm',
    'text-base': size === 'md',
    'text-lg': size === 'lg',
    'text-xl': size === 'xl',
    'text-2xl': size === '2xl',
    'text-3xl': size === '3xl',
    'text-neutral-80': true,
    'font-semibold': true,
    'ml-4': true,
  });

  return (
    <div data-testid="loading-view" className="flex items-center gap-0">
      <img
        data-testid="loading-img"
        className={logoClasses}
        src={LoaderSvg}
        alt={`Loading: ${message}`}
      />
      <span data-testid="loading-msg" className={textClasses}>
        {message}
      </span>
    </div>
  );
};
